import { useCallback, useState } from 'preact/hooks';
import { POST, POST_CLAIM_SEND_MSG_LINE_BULK } from '../../../../services';

const CHUNK_SIZE = 100;

const chunkArray = (items, size) => {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};

// ส่งทีละ chunk ตามลำดับ chunk ที่พังทั้งก้อนนับเป็น FAILED ทุกรายการ แต่ chunk ถัดไปยังทำงานต่อ
export const useBulkSendLineMessage = () => {
  const [isSending, setIsSending] = useState(false);
  const [sentCount, setSentCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [summary, setSummary] = useState(null);

  const reset = useCallback(() => {
    setIsSending(false);
    setSentCount(0);
    setTotalCount(0);
    setSummary(null);
  }, []);

  const send = useCallback(async (claims, message) => {
    const chunks = chunkArray(claims, CHUNK_SIZE);
    setIsSending(true);
    setSentCount(0);
    setTotalCount(claims.length);
    setSummary(null);

    let total = 0;
    let sent = 0;
    let skipped = 0;
    let failed = 0;
    let items = [];

    for (const chunk of chunks) {
      try {
        const response = await POST(POST_CLAIM_SEND_MSG_LINE_BULK(), {
          claimIds: chunk.map((claim) => claim.claimId),
          message,
        });
        if (response?.success === false) {
          throw new Error(response?.message || 'ส่งข้อความไม่สำเร็จ');
        }
        const result = response?.result || {};
        total += result.total ?? chunk.length;
        sent += result.sent ?? 0;
        skipped += result.skipped ?? 0;
        failed += result.failed ?? 0;
        items = items.concat(result.items || []);
      } catch (error) {
        const reason = error?.message || 'ส่งข้อความไม่สำเร็จ';
        total += chunk.length;
        failed += chunk.length;
        items = items.concat(
          chunk.map((claim) => ({
            claimId: claim.claimId,
            claimCode: claim.claimCode || '',
            status: 'FAILED',
            reason,
          })),
        );
      }
      setSentCount((prev) => prev + chunk.length);
    }

    const finalSummary = { total, sent, skipped, failed, items };
    setSummary(finalSummary);
    setIsSending(false);
    return finalSummary;
  }, []);

  return { send, reset, isSending, sentCount, totalCount, summary };
};
